// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common_close[data-v-ffa72c00]{display:inline-block;color:#d3d3d3;text-align:center;cursor:pointer}", ""]);
// Exports
module.exports = exports;
